import { usingGet, usingPost } from '@ocean/api'

export const getOnboardingConfiguration = () => usingGet(`Onboarding/Config`, { useProxy: true })

export const setUserOnbordingStatus = (viewed: boolean) =>
  usingPost(`Environment/SetUserOnboardingStatus`, { introductionWasSeen: viewed })
